import React from "react";
import { View, Platform } from "react-native";
import { TextInput } from "react-native-paper";
import { useTranslation } from "react-i18next";
import { useThemeSettings } from "../../../ThemeProvider";
import CustomLinearGradient, { GRADIENT_TYPE } from "../../../components/CustomLinearGradient";
import getGlobalStyles from "../../../globalStyles";

interface ShareCommentBoxProps {
  value: string;
  onChange: (text: string) => void;
  onFocusChange: (focused: boolean) => void;
}

const ShareCommentBox: React.FC<ShareCommentBoxProps> = ({ value, onChange, onFocusChange }) => {
  const { t } = useTranslation();
  const { theme } = useThemeSettings();
  const gStyles = getGlobalStyles();

  const handleFocus = () => {
    // Small delay avoids race condition in mobile browsers
    setTimeout(() => onFocusChange(true), 50);
  };

  const handleBlur = () => {
    setTimeout(() => onFocusChange(false), 50);
  };

  return (
    <View style={{ marginBottom: 20 }}>
      <CustomLinearGradient
        gradientType={GRADIENT_TYPE.MODAL}
        angle={90}
        style={{
          borderWidth: 1,
          borderColor: theme?.colors?.primary,
          borderRadius: 16,
          paddingHorizontal: 14,
          paddingVertical: 6,
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <TextInput
          mode="flat"
          placeholder={t("screens.share.commentPlaceholder")}
          placeholderTextColor={theme?.colors?.primaryLight}
          value={value}
          onChangeText={onChange}
          underlineColor="transparent"
          activeUnderlineColor="transparent"
          style={{
            flex: 1,
            height: 44,
            fontSize: 14,
            color: theme?.colors?.primary,
            backgroundColor: "transparent",
          }}
          contentStyle={{ paddingLeft: 0 }}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
      </CustomLinearGradient>
    </View>
  );
};

export default ShareCommentBox;